const getFilterValue = ({ options = [] }) => {
  const [valueFromApi] = options.filter(el => el.is_default === true);
  return valueFromApi || options[0];
};

// eslint-disable-next-line import/prefer-default-export
export { getFilterValue };
